import { Box, Button, Collapse, Heading } from "@chakra-ui/react"
import { MDXRemote, MDXRemoteSerializeResult } from "next-mdx-remote"
import { useEffect, useState } from "react"

const ProductDescription = ({
  mdxDescription,
  simpleDescription,
}: {
  mdxDescription?: MDXRemoteSerializeResult | null
  simpleDescription?: string
}) => {
  const [show, setShow] = useState(false)
  const handleToggle = () => setShow(!show)

  useEffect(() => {
    setShow(false)
  }, [mdxDescription, simpleDescription])

  return (
    <Box>
      <Heading size={"md"}>{"Description"}</Heading>
      <Collapse
        startingHeight={160}
        in={show}
      >
        {mdxDescription ? (
          <MDXRemote {...mdxDescription} />
        ) : simpleDescription ? (
          simpleDescription
        ) : (
          "No description available."
        )}
      </Collapse>
      <Button
        size={"sm"}
        variant={"link"}
        onClick={handleToggle}
        color={"blue.600"}
        textDecoration={"underline"}
        textDecorationStyle={"dashed"}
        textUnderlineOffset={"0.3em"}
        _hover={{
          textDecoration: "none",
        }}
      >
        {show ? "Show Less" : "Read More"}
      </Button>
    </Box>
  )
}

export default ProductDescription
